import { Link } from "react-router-dom";

function isExternal(to = "") {
  return /^https?:\/\//.test(to);
}

export default function MobileNavDrawer({
  mobileOpen,
  navItems,
  pathname,
  hash,
  section,
  subNavSection,
  activeTo,
  authUser,
  onClose,
  onSignOut,
}) {
  if (!mobileOpen) {
    return null;
  }

  return (
    <div className="nav-mobile-drawer">
      {subNavSection?.items?.length ? (
        <div className="nav-mobile-section">
          <div className="nav-mobile-section-label">{section?.label || subNavSection.label}</div>
          <div className="nav-mobile-subnav">
            {subNavSection.items.map((item) => {
              const itemHash = item.to.includes("#") ? item.to.split("#")[1] : "";
              const itemPath = itemHash ? item.to.split("#")[0] : item.to;
              const Icon = item.icon;
              const active =
                activeTo === item.to ||
                (!activeTo && itemHash && pathname === itemPath && (hash || "").replace(/^#/, "") === itemHash) ||
                (!activeTo && !itemHash && pathname === itemPath);

              const className = `nav-mobile-subnav-item${active ? " active" : ""}`;

              if (/^https?:\/\//.test(item.to)) {
                return (
                  <a key={item.to} href={item.to} target="_blank" rel="noopener noreferrer" className={className} onClick={onClose}>
                    {Icon ? <Icon className="nav-mobile-subnav-icon" size={13} strokeWidth={1.75} aria-hidden="true" /> : null}
                    {item.label}
                  </a>
                );
              }

              return (
                <Link key={item.to} to={item.to} className={className} onClick={onClose}>
                  {Icon ? <Icon className="nav-mobile-subnav-icon" size={13} strokeWidth={1.75} aria-hidden="true" /> : null}
                  {item.label}
                </Link>
              );
            })}
          </div>
          {subNavSection.cta ? (
            isExternal(subNavSection.cta.to) ? (
              <a
                href={subNavSection.cta.to}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-white"
                onClick={onClose}
                style={{ marginTop: 6, alignSelf: "flex-start" }}
              >
                {subNavSection.cta.label} ->
              </a>
            ) : (
              <Link
                to={subNavSection.cta.to}
                className="btn btn-sm btn-white"
                onClick={onClose}
                style={{ marginTop: 6, alignSelf: "flex-start" }}
              >
                {subNavSection.cta.label} ->
              </Link>
            )
          ) : null}
        </div>
      ) : null}

      <ul className="nav-mobile-links">
        {navItems.map((item) => {
          const navTo = item.to || item.path;

          return (
            <li key={item.label}>
              {isExternal(navTo) ? (
                <a
                  className={`nav-mobile-link${section?.label === item.label ? " active" : ""}`}
                  href={navTo}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  className={`nav-mobile-link${section?.label === item.label ? " active" : ""}`}
                  to={navTo}
                  onClick={onClose}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
      <div className="nav-mobile-divider" />
      {authUser ? (
        <>
          <Link to="/dashboard" className="nav-mobile-link" onClick={onClose}>
            Dashboard
          </Link>
          <Link to="/profile" className="nav-mobile-link" onClick={onClose}>
            Profile
          </Link>
          <button
            onClick={onSignOut}
            className="nav-mobile-link"
            style={{
              color: "#f87171",
              border: "none",
              background: "none",
              fontFamily: "inherit",
              cursor: "pointer",
              width: "100%",
              textAlign: "left",
            }}
          >
            Sign out
          </button>
        </>
      ) : (
        <Link
          to="/#contact"
          className="btn btn-sm btn-white btn-full"
          onClick={onClose}
          style={{ marginTop: 8 }}
        >
          Contact Team
        </Link>
      )}
    </div>
  );
}
